import { useState } from 'react'
import { Switch, Route, Link } from 'react-router-dom'

import Strings from '../Strings'
import SensorEnrollmentsList from './SensorEnrollmentsList'
import UpsertEnrollmentModal from './UpsertEnrollmentModal'

import { Flex, Text, Button } from '@/primitives'

import { LineSeparator } from '@/elements'

export default function OpsPage() {
  const [refreshTrigger, setRefreshTrigger] = useState(0)

  const strings = Strings()

  const handleRefresh = () => {
    setRefreshTrigger(prev => prev + 1)
  }

  return (
    <div>
      <Flex alignMainAxis='space-between' alignCrossAxis='center'>
        <Text size='300' variant='page' tone='800' fontWeight='300'>
          {strings.opsTab}
        </Text>
        <Button
          variant='primary'
          size='small'
          as={Link}
          to={{
            pathname: '/admin/ops/add'
          }}
        >
          {strings.linkSensors}
        </Button>
      </Flex>
      <LineSeparator />
      <SensorEnrollmentsList refreshTrigger={refreshTrigger} />
      <Switch>
        <Route path='/admin/ops/add'>
          <UpsertEnrollmentModal onSuccess={handleRefresh} />
        </Route>
        <Route path='/admin/ops/:enrollmentId/edit'>
          <UpsertEnrollmentModal onSuccess={handleRefresh} />
        </Route>
      </Switch>
    </div>
  )
}
